import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/components/LoginPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: LoginPage // 登录页面路由配置
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js